export default __webpack_public_path__ + "static/media/category6.3592424e.png";